class SalesRepPicker extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select[name="sales_rep"]');
    if (this.select) {
      this.select.addEventListener('change', this.onSalesRepChange.bind(this));
    }
  }

  connectedCallback() {
    this.initializeCartAttribute();
  }

  initializeCartAttribute() {
    if (this.select && this.select.value) {
      this.updateCartAttribute(this.select.value);
    }
  }

  onSalesRepChange(event) {
    const selectedTag = event.target.value;
    this.updateCartAttribute(selectedTag);
  }

  async updateCartAttribute(salesRepCode) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            sales_rep_code: salesRepCode
          }
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const cart = await response.json();
      this.dispatchEvent(new CustomEvent('sales-rep-updated', {
        bubbles: true,
        detail: {
          salesRepCode: salesRepCode,
          cart: cart
        }
      }));
    } catch (error) {
      console.error('Failed to update cart attribute:', error);
    }
  }

  getSelectedSalesRep() {
    if (!this.select) return null;
    const selectedOption = this.select.selectedOptions[0];
    if (!selectedOption) return null;

    return {
      tag: selectedOption.value,
      name: selectedOption.dataset.name || selectedOption.textContent.trim()
    };
  }
}

customElements.define('sales-rep-picker', SalesRepPicker);
